import { WITHDRAWAL_FIND, WITHDRAWAL_REQUEST } from "../../routes";
import customAxios from "../../customAxios";
import { IWithdrawalRequest } from "../../../types/common.interface";

async function withdrawalRequest(props: IWithdrawalRequest) {
  const thisUrl = WITHDRAWAL_REQUEST;

  let body: any = {
    amount: props.amount,
    shabaId: props.shabaId,
    bankId: props.bankId,
    bankName: props.bankName,
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default withdrawalRequest;
